import React from 'react';

import about from '../assets/images/about/about.jpg';


export default props =>{


    return(
        <section id='about'  style={{backgroundColor: '#fdebe2'}}>
        <div className="container">
            <h3 className='white-color' style={{color: '#737272'}}>About</h3>
            <hr className='white-color' style={{backgroundColor: '#737272'}}/>
            <div className="row">
        <div className="col s12 m12" style={{textAlign:'center'}}>
  

          <img style={{objectFit:'contain', width:'35%', minWidth:'200px', height: 'auto'}} src={about} />    

 

        </div>
        </div>

        <div className="row">
        <div className="col s12 m12 white-color" style={{color: '#737272'}}>
          <p>“No one look exactly the same. And everyone has its own definition for beauty. My job is to achieve the look in your mind.”</p>
          <p>A professional makeup artist and hair stylist will make you look like the beauty you want to be. Ever since 4, Ashley loves painting. She won 3 awards at 23rd Japan International Children’s Art Exhibition. With years of practice, She has a high color sensitivity. She is now still doing digital painting for a few startup companies. She also has 10 year background in biotech industry. With all the lab work experiences, she is very good at precision operation.</p>
          <p>“After they learned I was a biotech researcher, a lot people have asked me how I became a makeup artist and hair stylist. Many people thought these two jobs are very different. But as I do more and more, I realized they all require detail oriented, precise hand work and project management. I am always the one can do good makeup and hair among friends. After helping a few friends with their weddings and special events, I sensed the good opportunity to start a career change. I know I want to be professional makeup artist.”</p>
          <p>Ashley graduated from the largest image design school in China – MGP Image Design Art School. After she moved to the SF bay area with her family, she took the professional makeup and hair classes at Alist to learn more about the styles in the US. In addition, her multi-cultural life background greatly helps her to put Chinese and other Asian concepts into the styles for her clients. She believes no detail is overlooked.</p>
          <p>“It would be my great pleasure to assist you in your special day. I would be more than happy to be part of it! Let me make you feel stunningly beautiful in front of your family and friends, and mostly the person you will spend the rest of your life with!”</p>
        </div>

 
        
      </div>


    

 


        </div>
        </section>
    );
}


// WEBPACK FOOTER //
// ./src/components/about.js